// extracted by mini-css-extract-plugin
export default {"container":"r_2Nz","color":"c9Omd"};